"use client"

import { useState } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import axios from "axios"
import { FaExclamation } from "react-icons/fa6"
import { useLocation, useNavigate } from "react-router"
const EmailCheck = () => {
  const [captchaToken, setCaptchaToken] = useState("")
  const [error, setError] = useState({})
  const [email, setEmail] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const navigate = useNavigate()
  const validateForm = () => {
    const newErrors = {}
    if (!captchaToken) {
      newErrors.captcha = "No captcha"
    }
    if (!email) {
      newErrors.email = "No email"
    }
    setError(newErrors)
    return Object.keys(newErrors).filter((e) => e !== "").length === 0
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validateForm()) {
      return
    }
    setIsLoading(true)
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}api/submit-email`, {
      email: email,
      captcha: captchaToken,
    })
    if (!response.data.success) {
      setIsLoading(false)
      response.data.type.includes("Email") ? 
      setError((prev) => ({
        ...prev,
        email:response.data.message
      })) :
      setError((prev) => ({
        ...prev,
        captcha: "failed",
      }))
      return
    }
    localStorage.setItem("userId", response.data.user.ID)
    navigate("/feedback", { replace: true })
  }
  return (
    <div className="email-check">
      <h1 className="email-form-header">Attendance certificate</h1>
      <h5 style={{margin:0}}>To obtain the attendance certificate, please fill the following feedback form.</h5>
      <h5 style={{margin:0}}>Once you submit the form, you will automatically be given the option to download your Attendance Certificate.</h5>
      
      <form className="email-check-form" onSubmit={handleSubmit}>
        <div className="form-control">
          <label htmlFor="email-form-input" className="form-label">
            Enter your registered email address
          </label>
          <input
            type="email"
            onChange={(e) => {
              setEmail(e.target.value)
              setError((prev) => ({
                ...prev,
                email: "",
              }))
            }}
            id="email-form-input"
            name="email-form-input"
            className={`form-input ${error.email && "error"}`}
            placeholder="Your email"
          />
          {error.email && <span className="unregistered">{error.email}</span>}
          {error.email && <FaExclamation className="error-msg"></FaExclamation>}
        </div>
        <div className="form-control captcha">
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
            onChange={(token) => setCaptchaToken(token)}
          />
          {error.captcha && <FaExclamation className="error-msg captcha"></FaExclamation>}
        </div>
        <div style={{textAlign:"center"}}>

          <button className="submit-btn">{isLoading ? "Verifying..." : "Verify"}</button>
        </div>
      </form>
    </div>
  )
}

export default EmailCheck
